'use strict';

var DeleteTokenService = function DeleteTokenService(Restangular) {
  function deleteToken() {
    var logoutService = Restangular.service('logout');
    return logoutService.post();
  }
  return {
    deleteToken: deleteToken
  };
};
DeleteTokenService.$inject = ['Restangular'];
module.exports = DeleteTokenService;